import React, { memo } from 'react'

import BuildingDetailsView from './BuildingDetailsView'
import EquipmentDetailsView from './EquipmentDetailsView'
import useTranslations from '../../../hooks/useTranslations'
import ANTDCard from '../../../shared/antd/ANTDCard'
import ANTDTable, {
  ANTDTableCell,
  ANTDTableRow,
} from '../../../shared/antd/ANTDTable'
import PieChartUI from '../../../shared/chart/PieChartUI'
import { isEqual } from '../../../utils/javascript'
import { equipmentColumn } from '../container/visualizationColumns'

function EquipmentCardView({
  equipmentLoader,
  equipmentData,
  pieChartData,
  buildingEquipmentDetails,
  currentSelectedType,
  viewType,
  handleEquipmentList,
  brandTotal,
}) {
  const { t } = useTranslations()
  return (
    <>
      <ANTDCard className={`h-100 overflowY-auto`}>
        <h3 className="mb-15">{t('dvz_RepairJobSummaryByBrandPSModel')}</h3>
        {isEqual(currentSelectedType, 'user_Building') ? (
          <BuildingDetailsView
            {...{
              details: buildingEquipmentDetails?.buildingInfo,
              viewType,
              handleEquipmentList,
            }}
          />
        ) : null}
        {isEqual(currentSelectedType, 'txt_Equipment') ? (
          <EquipmentDetailsView
            {...{ details: buildingEquipmentDetails?.equipmentInfo }}
          />
        ) : null}
        <ANTDTable
          id="equipment-table"
          className="refrigerant-table mt-20"
          columns={equipmentColumn()}
          dataSource={equipmentData?.list}
          scroll={{ y: 300 }}
          pagination={false}
          loading={equipmentLoader}
          bordered
          summary={() => {
            return (
              <ANTDTableRow>
                <ANTDTableCell className="text-center" colSpan={3}>
                  {t('dvz_Total')}
                </ANTDTableCell>
                <ANTDTableCell>
                  {brandTotal?.totalRepairJobsCreated || 0}
                </ANTDTableCell>
                <ANTDTableCell>
                  {brandTotal?.totalRepairJobsClosed || 0}
                </ANTDTableCell>
              </ANTDTableRow>
            )
          }}
        />
        <div className="mt-30">
          {pieChartData && (
            <h3>{t('dvz_DistributionOfRepairJobsByErrorCode')}</h3>
          )}
          <PieChartUI {...{ pieChartData }} />
        </div>
      </ANTDCard>
    </>
  )
}

export default memo(EquipmentCardView)
